<script setup>
// IMPORTS
import { useRoute } from "vue-router";

import TopBarUserProfile from "@/shared/layout/TopBarUserProfile.vue";

import Logo from "@/assets/images/logo.svg?url";

// DEPENDENCIES
const { isMainNavOpen } = useApp();

const route = useRoute();

// INJECT

// PROPS, EMITS

// REFS

// COMPUTED

// COMPONENT METHODS AND LOGIC
const handleLogoClick = () => {
  if (route.path.includes("editor")) {
    isMainNavOpen.value = !isMainNavOpen.value;
  }
};

// PROVIDE, EXPOSE

// WATCHERS

// LIFECYCLE METHODS (https://vuejs.org/api/composition-api-lifecycle.html)
</script>

<template>
  <div class="topbar heading-lg flex items-center px-2 py-1 text-white">
    <img
      class="topbar__logo cursor-pointer"
      :src="Logo"
      alt="Logo"
      @click="handleLogoClick"
    />
    <TopBarUserProfile />
  </div>
</template>

<style scoped lang="scss">
$topbar-height: 60px;

.topbar {
  background: linear-gradient(90deg, #002122 0%, #002122 39.6%, #004a4b 61.6%, #008e90 83.6%, #00bfc1 100%);

  box-shadow: 0px 4px 10px 0px #00000080;
  height: $topbar-height;
  z-index: 40;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  &__logo {
    height: 46px;
    width: auto;
  }
}
</style>
